import RecentCallDTO from '@/Helpers/Doctor/Dto/RecentCall.dto';
import PaginationHelper from '@/Helpers/pagination.helper';
import DownloadHelper from '@/Helpers/Download.helper';
export default {
  data() {
    return {
      recentCallsList: [],
    };
  },
  mixins: [RecentCallDTO, PaginationHelper, DownloadHelper],
  methods: {
    getRecentCallsListHandler: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getRecentCallsList', params)
        .then(() => {
          if (this.$store.state.recent800CallsModule.successFlag) {
            const data = this.$store.state.recent800CallsModule.recentCallsResponse;
            this.setPagination(data);
            this.recentCallsList = this.transformRecentCallsList([...data?.items]);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.recent800CallsModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getRecentCallsListHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.recent800CallsModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getRecentCallsListHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    playAudioHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('listenToCallDispatch', id).then(() => {
        if (this.$store.state.recent800CallsModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.recent800CallsModule.file) {
            const url = window.URL.createObjectURL(
              new Blob([this.$store.state.recent800CallsModule.file]),
            );
            // this.recordFile = url;
            // this.player = true;
            try {
              this.$root.$refs.Home.recordFileHome = url;
              this.$root.$refs.Home.playerHome = true;
            } catch (error) {
              console.log('A Error accessing Home component:', error);
            }
          } else {
            this.snackText = 'فایل صوتی جهت پخش وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.recent800CallsModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.recent800CallsModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    downloadAudioFileHandler: function (id, fileName) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('listenToCallDispatch', id).then(() => {
        if (this.$store.state.recent800CallsModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          const audioFile = this.$store.state?.recent800CallsModule?.file;
          if (audioFile) {
            this.downloadFile(audioFile, fileName);
          } else {
            this.snackText = 'فایل صوتی جهت پخش وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.recent800CallsModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.recent800CallsModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
  },
};
